import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormikContext } from 'formik'

import request from '@/modules/base/util/request'
import settingsConfig from '@/modules/settings/config'
import SelectInput from '@/modules/base/components/inputs/select-input/select-input'
import lang from '@/lang'
import { getMiscellaneousData } from '@/modules/base/helpers/getSettingsData'

import { toast } from '@/modules/base/components/toast/toastConfig'

class JobTitleInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      shouldRefresh: false,
    }

    this.jobTitles = []
    this.getJobTitles = this.getJobTitles.bind(this)
    this.handleJobTitleChange = this.handleJobTitleChange.bind(this)
    this.handleJobTitleCreated = this.handleJobTitleCreated.bind(this)
    this.getJobTitleselectProps = this.getJobTitleselectProps.bind(this)
  }

  getJobTitles(search) {
    return getMiscellaneousData()
      .then((response) => {
        const { body: { data: { jobTitles } } } = response
        this.jobTitles = jobTitles

        const mappedJobTitles = jobTitles
          .map(jobTitle => ({ name: jobTitle }))

        if (search) {
          return mappedJobTitles.filter(jobTitle => jobTitle.name.toLowerCase().includes(search.toLowerCase()))
        }

        return mappedJobTitles
      })
  }

  getJobTitleselectProps() {
    const { isInline, name = 'jobTitle', useFormik } = this.props

    const fieldMeta = useFormik === undefined || useFormik ? this.context?.getFieldMeta(name) : null
    const value = fieldMeta ? fieldMeta.value : this.props.value

    return {
      label: 'Position',
      name,
      allowCreate: true,
      notAsync: false,
      isInline,
      customSelectOptions: {
        placeholder: lang.selectInput.createPlaceholder,
        valueKey: 'name',
        labelKey: 'name',
        isClearable: true,
        loadOptions: this.getJobTitles,
        defaultOptions: true,
      },
      value: value ? { name: value } : '',
      handleChange: this.handleJobTitleChange,
      onOptionCreated: this.handleJobTitleCreated,
      useFormik: false,
    }
  }

  handleJobTitleChange(option) {
    const { onChange } = this.props
    onChange && onChange(option ? option.name : '')
  }

  handleJobTitleCreated(option) {
    const newJobTitles = this.jobTitles.concat([option])

    request(settingsConfig.contact, {
      auth: true,
      method: 'POST',
      data: { jobTitles: newJobTitles },
    })
      .then(() => {
        toast.showToast({ message: lang.contactPersonForm.jobTitle.optionCreated(option) })
        this.jobTitles = newJobTitles
        this.handleJobTitleChange({ name: option })
        this.setState((prevState) => ({ shouldRefresh: !prevState.shouldRefresh }))
      })
  }

  render() {
    // necessary for refreshing options if a new one was created
    const { shouldRefresh } = this.state
    const { customClass, dropDownMaxHeight, dataQsId } = this.props
    const jobTitleSelectProps = this.getJobTitleselectProps()

    return (
      <SelectInput dataQsId={dataQsId} className={customClass} customKey={shouldRefresh} {...jobTitleSelectProps} dropDownMaxHeight={dropDownMaxHeight} />
    )
  }
}

JobTitleInput.contextType = FormikContext

JobTitleInput.propTypes = {
  isInline: PropTypes.bool,
  useFormik: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  customClass: PropTypes.string,
  onChange: PropTypes.func,
  dropDownMaxHeight: PropTypes.string,
  dataQsId: PropTypes.string.isRequired,
}

JobTitleInput.defaultProps = {
  isInline: false,
  dropDownMaxHeight: undefined,
}

export default JobTitleInput
